import { del, get, post } from '../../common/axiosClient';
import { API } from '../../common/constants/urls';

// ... other imports and methods

export const deleteLineItem = async (id: string) => {
  return await del(`${API.LINE_ITEMS}/${id}`);
};
export const bulkDeleteLineItems = async (ids: string[]) => {
  return await del(`${API.LINE_ITEMS}/bulk-delete`, {
    headers: {
      'Content-Type': 'application/json',
    },
    data: JSON.stringify(ids),
  });
};
export const createLineItem = async (newLineItemData: any) => {
  return await post(`${API.LINE_ITEMS}`, newLineItemData);
};
export const fetchPaginatedLineItems = async (queryParams: string[]) => {
  const queryString = queryParams.join('&');
  return await get(`${API.LINE_ITEMS}/paginated?${queryString}`);
};

export const searchLineItems = async (description: string) => {
  return await get(`${API.LINE_ITEMS}/search?description=${encodeURIComponent(description)}`);
};
